<section>

  <p>
    <a
      class="btn btn-secondary"
      [routerLink]="['/admin', 'posts', 'create']">
      Create
    </a>
  </p>

  <table
    class="table"
    *ngIf="posts?.length > 0">
    <thead>
      <tr>
        <th>#</th>
        <th>Title</th>
        <th>Date</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let post of posts; let idx = index">
        <td>{{ idx + 1 }}</td>
        <td>{{ post.title }}</td>
        <td>{{ post.date | date: 'medium' }}</td>
        <td>
          <a
            class="btn btn-secondary"
            [routerLink]="['/admin', 'posts', post.id, 'edit']">
            Edit
          </a>
          <button
            class="btn btn-danger"
            (click)="remove(post.id)">
            Delete
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</section>
